import { getMyGameDataList, setMyGameDataList } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人分享的游戏数据
      myGameDatasList: getMyGameDataList()
    }
  },
  getters: {

  },
  mutations: {
    setMyGameDataList (state, obj) {
      state.myGameDatasList = obj
      setMyGameDataList(obj)
    }
  },
  actions: {
  }
}
